import classNames from 'classnames'
import React, { CSSProperties, useState } from 'react'
import Icon from 'meinian-package/src/component/icon'
import { Element } from './element'
import styles from './index.module.less'

interface RecordInfoCardProps {
    className?:string,
    style?:CSSProperties,
    boxLabelRetList?:any;
    onFeedback?:()=>void,
  }

const RecordInfoCard = ({ className, boxLabelRetList, style, onFeedback }:RecordInfoCardProps) => {
  const [value, setValue] = useState(0)
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{
    !!boxLabelRetList?.length && <div
      className={classNames(styles['mn-record-info-card'], className)}
      style={style}
    >

      <Element
        boxIndex={value}
        setBoxIndex={setValue}
        boxLabelRetList={boxLabelRetList}
      >
        <div className="mn-record-info-card-footer">
          <Icon type="m-xinxi_miaobian" className="mn-record-info-card-footer-icon" />
          <div className="mn-record-info-card-footer-info">识别有误？</div>
          <div
            className="mn-record-info-card-footer-btn"
            onClick={() => {
              onFeedback()
            }}
          >提交反馈</div>
        </div>
      </Element>
    </div>
}
  </>
}
export default RecordInfoCard
